import { Stack, Typography } from "@mui/material";

export default function PartyPieper() {
  return (
    <Stack bgcolor="#F4F8FF" p={8} spacing={5}>
      <Stack alignItems="center" spacing={3} mt={8}>
        <Typography color="#20487E" variant="h3" fontWeight="bold">
          De PartyPieper
        </Typography>
      </Stack>

      <img src={require("../Assets/Images/partyPieper.png")} alt="" />
      <img src={require("../Assets/Images/partyPieperApp.jpg")} alt="" />
    </Stack>
  );
}
